import {
  isSymbolRoot,
  isSymbolInst,
} from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

// Note: This deletes symbol instances inside of symbol roots (ie: nested symbols)
// We opted not to expand the instances into subtrees with new guids or at all
// to avoid recursion complexities (where an instance references its ancestor symbol root,
// or two or more instances reference each other's ancestor symbol root).

// Deleting the nested instances should be safe since the root symbol they point to will still exist.

export default (context: Context) => {
  const {
    node: {jsonNode},
    // eslint-disable-next-line webflow/deprecated
    fn: {__DEPRECATED__scanSubtree, __DEPRECATED__dropNodeAndChildren},
  } = context;
  const {data = {}} = jsonNode;
  const nodeIsSymbolRoot = isSymbolRoot(data);
  const nestedSymbolInstanceIds: Array<any> = [];

  // If this is a symbol root, check if any of its descendants are symbol instances
  // and add them to the list.
  if (nodeIsSymbolRoot) {
    __DEPRECATED__scanSubtree(jsonNode, (child) => {
      if (isSymbolInst(child.data)) {
        nestedSymbolInstanceIds.push(child);
      }
    });
  }

  return {
    needed: Boolean(nestedSymbolInstanceIds.length),
    logData: {
      msg: 'Nested Symbol Instance in Symbol Root',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // Remove every nested symbol instance we found in this symbol root
      nestedSymbolInstanceIds.forEach((nestedInstance) => {
        __DEPRECATED__dropNodeAndChildren(nestedInstance);
      });
    },
  };
};
